import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import { useRecordContext, useTranslate } from "react-admin"

export const OptionalServicesModal = ({open, handleClose, data }) =>{
    const translate = useTranslate()
    return(
        <Dialog open={open} maxWidth='lg'>
            <DialogTitle>
                <Typography variant='h6' component='div' textAlign={'center'}>
                {data?.optional}
                </Typography>
            </DialogTitle>
            <DialogContent>
            <Box style={{ border: '4px solid #F9F9FD', borderRadius: '10px', padding: 10 }}>
                <div style={{display:'flex', flexDirection:'column'}}>
                    {data &&
                        Object.entries(data).map(([field, value])=>(
                            field !== 'optional' &&
                            <label>
                                {`${translate('ra.field.'+field)}: ${value}`}
                            </label>
                        ))
                    }
                </div>
            </Box>
            <DialogActions className='dialog-actions' style={{ marginTop: '20px' }}>
                <Button onClick={handleClose} variant='outlined' color='error'>
                {translate('ra.action.close')}
                </Button>
            </DialogActions>
            </DialogContent>
        </Dialog>
    )
}